var r = /*#__PURE__*/function () {
  function r(e) {
    void 0 === e && (e = r.defaultCreateUrl), this.createURL = void 0, this.createURL = e;
  }

  return r.defaultCreateUrl = function (r, e) {
    return "https://" + r + ".ipns.dweb.link" + e.replace(/^\/?/, "/");
  }, r.prototype.resolve = function (r) {
    try {
      var e, t, n;
      if (r.startsWith("/ipfs/") || r.startsWith("/ipns/")) n = r.substring(1, 5), e = r.substring(6).split("/")[0], t = r.substring(6 + e.length);else {
        var o = new URL(r);
        if ("" !== o.hash || "" !== o.password || "" !== o.port || "" !== o.search || "" !== o.username) throw new Error("invalid ipfs uri");
        n = o.protocol.substring(0, 4), e = o.hostname, t = o.pathname;
      }
      if ("ipfs" !== n) throw new Error("only ipfs is supported, (not ipns)");
      return Promise.resolve(fetch(this.createURL(e, t)).then(function (r) {
        return r.ok ? r.text() : Promise.reject(new Error("bad response"));
      }));
    } catch (r) {
      return Promise.reject(r);
    }
  }, r;
}(),
    e = /*#__PURE__*/function () {
  function r(r) {
    this.options = void 0, this.options = r;
  }

  return r.prototype.resolve = function (r, e) {
    try {
      var t,
          n = "";

      if (r.includes("@")) {
        var o = r.split("@", 1);
        n = o[0], t = o[1];
      } else t = r;

      var i = "http://openid.net/specs/connect/1.0/issuer";
      return Promise.resolve(this.options.webfingerResolver.resolve(t, n, i, e)).then(function (r) {
        var e,
            t = null == (e = r.links) ? void 0 : e.find(function (r) {
          return r.rel === i;
        });
        if (!t || !t.href) throw new Error("bad jrd");
        return Promise.resolve(fetch(t.href + "/.well-known/openid-configuration").then(function (r) {
          return r.ok ? r.json() : Promise.reject(new Error("bad openid-configuration response"));
        }));
      });
    } catch (r) {
      return Promise.reject(r);
    }
  }, r;
}();

function t(r) {
  return !0;
}

function n(r) {
  return !0;
}

function o(r, e, t) {
  if (!r.s) {
    if (t instanceof i) {
      if (!t.s) return void (t.o = o.bind(null, r, e));
      1 & e && (e = t.s), t = t.v;
    }

    if (t && t.then) return void t.then(o.bind(null, r, e), o.bind(null, r, 2));
    r.s = e, r.v = t;
    var _n = r.o;
    _n && _n(r);
  }
}

var i = /*#__PURE__*/function () {
  function r() {}

  return r.prototype.then = function (e, t) {
    var n = new r(),
        i = this.s;

    if (i) {
      var s = 1 & i ? e : t;

      if (s) {
        try {
          o(n, 1, s(this.v));
        } catch (r) {
          o(n, 2, r);
        }

        return n;
      }

      return this;
    }

    return this.o = function (r) {
      try {
        var i = r.v;
        1 & r.s ? o(n, 1, e ? e(i) : i) : t ? o(n, 1, t(i)) : o(n, 2, i);
      } catch (r) {
        o(n, 2, r);
      }
    }, n;
  }, r;
}();

if ("undefined" != typeof window) {
  var s = window;
  s.UAUTH_VERSION = s.UAUTH_VERSION || {}, s.UAUTH_VERSION.COMMON = "2.3.0";
}

var u = /*#__PURE__*/function () {
  function r(r) {
    this.options = void 0, this.options = r;
  }

  return r.prototype.resolve = function (r, e, t, n) {
    try {
      var s = this,
          u = "webfinger." + e + "." + t;
      return Promise.resolve(s.options.domainResolver.records(r, [u])).then(function (f) {
        function c(r) {
          if (h.subject !== a) throw new Error("resource invalid");
          return h;
        }

        var a = e ? "acct:" + e + "@" + r : "" + r;
        if (!f[u]) return {
          subject: a,
          links: [{
            rel: t,
            href: n
          }]
        };
        var h,
            v = JSON.parse(f[u]),
            p = "string" == typeof v.host ? Promise.resolve(fetch("/.well-known/webfinger?" + new URLSearchParams({
          resource: a,
          rel: t
        }).toString(), {
          headers: {
            Host: v.host
          }
        }).then(function (r) {
          return r.ok ? r.json() : Promise.reject(new Error("bad webfinger response"));
        })).then(function (r) {
          h = r;
        }) : function () {
          if ("string" == typeof v.uri) {
            var r = new URL(v.uri);
            return function (r, e) {
              var t,
                  n = -1;

              r: {
                for (var s = 0; s < e.length; s++) {
                  var u = e[s][0];

                  if (u) {
                    var f = u();
                    if (f && f.then) break r;

                    if (f === r) {
                      n = s;
                      break;
                    }
                  } else n = s;
                }

                if (-1 !== n) {
                  do {
                    for (var c = e[n][1]; !c;) {
                      n++, c = e[n][1];
                    }

                    var a = c();

                    if (a && a.then) {
                      t = !0;
                      break r;
                    }

                    var h = e[n][2];
                    n++;
                  } while (h && !h());

                  return a;
                }
              }

              var v = new i(),
                  p = o.bind(null, v, 2);
              return (t ? a.then(l) : f.then(function t(i) {
                for (;;) {
                  if (i === r) {
                    n = s;
                    break;
                  }

                  if (++s === e.length) {
                    if (-1 !== n) break;
                    return void o(v, 1, c);
                  }

                  if (u = e[s][0]) {
                    if ((i = u()) && i.then) return void i.then(t).then(void 0, p);
                  } else n = s;
                }

                do {
                  for (var f = e[n][1]; !f;) {
                    n++, f = e[n][1];
                  }

                  var c = f();
                  if (c && c.then) return void c.then(l).then(void 0, p);
                  var a = e[n][2];
                  n++;
                } while (a && !a());

                o(v, 1, c);
              })).then(void 0, p), v;

              function l(r) {
                for (;;) {
                  var t = e[n][2];
                  if (!t || t()) break;
                  n++;

                  for (var i = e[n][1]; !i;) {
                    n++, i = e[n][1];
                  }

                  if ((r = i()) && r.then) return void r.then(l).then(void 0, p);
                }

                o(v, 1, r);
              }
            }(r.protocol, [[function () {
              return "http:";
            }], [function () {
              return "https:";
            }, function () {
              return Promise.resolve(fetch(r.toString()).then(function (r) {
                return r.ok ? r.json() : Promise.reject(new Error("bad webfinger response"));
              })).then(function (r) {
                h = r;
              });
            }], [function () {
              return "ipfs:";
            }, function () {
              return Promise.resolve(s.options.ipfsResolver.resolve(v.uri)).then(function (r) {
                h = JSON.parse(r);
              });
            }], [function () {
              return "ipns:";
            }], [function () {
              return "swarm:";
            }], [void 0, function () {
              throw new Error("uri scheme not supported");
            }]]);
          }

          if ("string" != typeof v.value) throw new Error("bad webfinger record");
          h = JSON.parse(v.value);
        }();
        return p && p.then ? p.then(c) : c();
      });
    } catch (r) {
      return Promise.reject(r);
    }
  }, r;
}();

function f() {
  return f = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
      }
    }

    return r;
  }, f.apply(this, arguments);
}

var c = /*#__PURE__*/function () {
  function r() {
    var r = this;
    this.map = new Map(), this.records = function (e, t) {
      try {
        var n = r.map.get(e);
        if (0 === t.length) throw new Error("no keys");
        return Promise.resolve(n ? t.reduce(function (r, e) {
          return r[e] = n[e] || "", r;
        }, {}) : {});
      } catch (r) {
        return Promise.reject(r);
      }
    };
  }

  return r.prototype.set = function (r, e) {
    this.map.has(r) ? this.map.set(r, f({}, this.map.get(r), e)) : this.map.set(r, e);
  }, r;
}(),
    a = /*#__PURE__*/function () {
  function r() {
    this.map = new Map();
  }

  var e = r.prototype;
  return e.set = function (r, e, t, n) {
    this.map.set(r + "." + e + "." + t, n);
  }, e.resolve = function (r, e, t, n) {
    try {
      var o = this.map.get(r + "." + e + "." + t);
      return Promise.resolve(o || {
        subject: r,
        links: [{
          rel: t,
          href: n
        }]
      });
    } catch (r) {
      return Promise.reject(r);
    }
  }, r;
}();

export { r as DefaultIPFSResolver, e as DefaultIssuerResolver, u as DefaultWebFingerResolver, c as MemoryDomainResolver, a as MemoryWebFingerResolver, n as isJRD, t as isJRDLink };